import {
  Card,
  Heading,
  Stack,
  TableContainer,
  Text,
} from "@softmax/design-system";
import { PolicyStateFeedback, type PolicyRefreshState } from "../policy-state";
import type { PolicyVersionStatusEvent } from "../policy-version-records";
import { PolicyStatusHistory } from "./policy-status-history";

export type PolicyStatusHistoryPanelProps = {
  readonly statusHistory:
    | { readonly status: "loading" }
    | { readonly status: "error"; readonly message: string }
    | {
        readonly status: "ready";
        readonly events: readonly PolicyVersionStatusEvent[];
        readonly refresh?: PolicyRefreshState | undefined;
      };
  readonly onRetry?: (() => void) | undefined;
  readonly onOpenStatusSource: (key: string) => void;
};

export function PolicyStatusHistoryPanel({
  statusHistory,
  onRetry,
  onOpenStatusSource,
}: PolicyStatusHistoryPanelProps) {
  return (
    <Card>
      <Stack width="auto">
        <Heading level={2}>League status history</Heading>
        <PolicyStateFeedback
          state={statusHistory}
          subject="status history"
          onRetry={onRetry}
        />
        {statusHistory.status === "ready" &&
          (statusHistory.events.length === 0 ? (
            <Text tone="muted">No league status history yet.</Text>
          ) : (
            <TableContainer aria-label="Policy version league status history">
              <PolicyStatusHistory
                events={statusHistory.events}
                onOpenSource={onOpenStatusSource}
              />
            </TableContainer>
          ))}
      </Stack>
    </Card>
  );
}
